import {Link} from 'wouter'
import {ROUTES} from '../routes'

function NavLink({label, href}: {label: string; href: string}) {
    return (
        <Link
            href={href}
            className={active =>
                [
                    'px-4 py-2 text-sm font-mono tracking-widest uppercase transition-colors',
                    active ?
                        'text-foreground bg-surface-container-high'
                    :   'text-foreground/70 hover:text-foreground hover:bg-surface-container-high'
                ].join(' ')
            }
        >
            {label}
        </Link>
    )
}

export function TopMenu() {
    return (
        <header className='fixed top-0 inset-x-0 z-50 h-14 flex items-center border-b border-foreground/10 bg-white/20 backdrop-blur-[24px]'>
            <div className='flex items-center gap-6 px-6 w-full'>
                <span className='font-mono text-xs tracking-[0.3em] uppercase text-foreground/40 select-none'>
                    SYS/001
                </span>
                <div className='w-px h-5 bg-foreground/15' />
                <nav className='flex items-center gap-1'>
                    {ROUTES.map(route => (
                        <NavLink
                            key={route.path}
                            label={route.label}
                            href={route.path}
                        />
                    ))}
                </nav>
            </div>
        </header>
    )
}
